import { UISref } from "@uirouter/react";
import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import { PanelHeaderSummary } from "../Layout/Panel";

const HeaderSummary = () => (
  <PanelHeaderSummary>
    <div className="panel-summary__section-row --notification">
      <UISref to="add-notification">
        <span className="notification-card__link">
          <Icon className="notification-card__link --icon" id="send" />
          {i18n.t("notification.publish")}
        </span>
      </UISref>
    </div>
  </PanelHeaderSummary>
);

export default HeaderSummary;



// WEBPACK FOOTER //
// ./src/components/Notifications/HeaderSummary.js